export default function CGUS() {
  return (
    <div className="max-h-full overflow-auto p-10">
      <h1 className="-ml-2 mb-2 text-2xl font-bold">Conditions Générales d'Utilisation (CGU) - MEDSPOT</h1>
      <p>
        <strong>Date de mise à jour :</strong> 24/11/2024
      </p>

      <h2>1. Préambule</h2>
      <p>
        Les présentes Conditions Générales d'Utilisation (CGU) encadrent l'accès et l'utilisation de la plateforme{" "}
        <em>[Nom du réseau social]</em> (ci-après « la Plateforme »), réservée exclusivement aux professionnels de santé
        dûment certifiés. En créant un compte, vous acceptez les présentes CGU et vous engagez à respecter l'éthique
        professionnelle ainsi que les lois en vigueur, notamment le respect du secret médical.
      </p>

      <h2>2. Objet de la Plateforme</h2>
      <p>La Plateforme a pour objectif de permettre :</p>
      <ul>
        <li>La mise en relation des professionnels de santé ;</li>
        <li>Le partage de connaissances médicales et scientifiques ;</li>
        <li>Les discussions sur des cas médicaux anonymisés à des fins éducatives ou collaboratives.</li>
      </ul>
      <p>
        <strong>Attention :</strong> Toute mention directe ou indirecte permettant d'identifier un patient est
        strictement interdite.
      </p>

      <h2>3. Conditions d'accès</h2>
      <p>
        <strong>Réservé aux professionnels de santé :</strong> L'inscription est exclusivement ouverte aux médecins et
        professionnels de santé habilités. Un justificatif de qualification (n° RPPS, diplôme, etc.) peut être exigé
        pour valider votre compte.
      </p>
      <p>
        <strong>Authenticité des informations :</strong> Vous vous engagez à fournir des informations exactes et à jour
        lors de l'inscription.
      </p>
      <p>
        <strong>Âge minimum :</strong> Vous devez être âgé d’au moins 18 ans pour utiliser la Plateforme.
      </p>

      <h2>4. Règles d'utilisation</h2>
      <p>En utilisant la Plateforme, vous vous engagez à respecter les règles suivantes :</p>
      <h3>4.1. Éthique professionnelle</h3>
      <ul>
        <li>
          Ne pas publier ou partager des contenus contraires à la déontologie médicale ou à l’éthique professionnelle.
        </li>
        <li>Maintenir une conduite respectueuse envers les autres membres.</li>
      </ul>
      <h3>4.2. Respect du secret médical</h3>
      <ul>
        <li>Interdiction stricte de mentionner des noms ou toute information permettant d’identifier un patient.</li>
        <li>
          Tout cas médical discuté sur la Plateforme doit être anonymisé (pas de nom, de date précise, de localisation
          identifiable, ou de toute autre information personnelle).
        </li>
      </ul>
      <h3>4.3. Contenus partagés</h3>
      <ul>
        <li>Ne pas publier de contenu diffamatoire, injurieux, discriminatoire ou à caractère violent.</li>
        <li>Ne pas partager de fausses informations médicales ou non vérifiées.</li>
      </ul>

      <h2>5. Propriété intellectuelle</h2>
      <p>Les contenus publiés sur la Plateforme par les membres restent la propriété de leurs auteurs respectifs.</p>
      <p>
        Vous accordez à <em>[Nom du réseau social]</em> une licence non exclusive pour utiliser, héberger, et afficher
        vos contenus dans le cadre du fonctionnement de la Plateforme.
      </p>
      <p>
        Tout contenu appartenant à la Plateforme (logos, interfaces, codes, etc.) est protégé par des droits de
        propriété intellectuelle et ne peut être utilisé sans autorisation préalable.
      </p>

      <h2>6. Responsabilité</h2>
      <h3>6.1. Responsabilité de l'utilisateur</h3>
      <p>Vous êtes seul responsable des contenus que vous publiez ou partagez sur la Plateforme.</p>
      <p>
        Vous vous engagez à ne pas enfreindre les lois, notamment celles relatives au secret médical et à la
        confidentialité des données personnelles.
      </p>
      <h3>6.2. Limitation de responsabilité de la Plateforme</h3>
      <p>La Plateforme ne garantit pas l’exactitude des informations publiées par les utilisateurs.</p>
      <p>
        En cas de violation des CGU, la Plateforme se réserve le droit de suspendre ou supprimer un compte sans préavis.
      </p>

      <h2>7. Données personnelles</h2>
      <p>
        Votre utilisation de la Plateforme implique la collecte et le traitement de certaines données personnelles,
        conformément à notre <em>[Politique de Confidentialité]</em>. Ces données ne seront utilisées que pour assurer
        le fonctionnement de la Plateforme et en conformité avec le Règlement Général sur la Protection des Données
        (RGPD).
      </p>

      <h2>8. Sanctions</h2>
      <p>Tout manquement aux présentes CGU, notamment au respect du secret médical, pourra entraîner :</p>
      <ul>
        <li>Un avertissement.</li>
        <li>La suspension temporaire de votre compte.</li>
        <li>La suppression définitive de votre compte, sans possibilité de recours.</li>
        <li>Le signalement aux autorités compétentes en cas de violation grave.</li>
      </ul>

      <h2>9. Modification des CGU</h2>
      <p>
        Les présentes CGU peuvent être modifiées à tout moment pour s'adapter aux évolutions de la Plateforme ou aux
        obligations légales. Vous serez informé de toute modification et votre utilisation continue de la Plateforme
        vaudra acceptation des nouvelles CGU.
      </p>

      <h2>10. Loi applicable et juridiction compétente</h2>
      <p>
        Les présentes CGU sont régies par les lois en vigueur en <em>France</em>.
      </p>

      <h2>11. Contact</h2>
      <p>
        Pour toute question ou réclamation concernant ces CGU, vous pouvez nous contacter à{" "}
        <a href="mailto:contact@medspot.fr">contact@medspot.fr</a>.
      </p>
    </div>
  );
}
